export const runtimeEnvironment = {
  BUILD_NUMBER: 'b9592602-e27a-4ddd-b196-9360a1dde2bd',
  SENTRY_ENABLED: true,
};
